import { useTranslation } from "react-i18next"
import { Button } from "./ui/Button"
import { useAuth } from "@/utils/auth"

export const AppBlockScreen = (props: { reason: React.ReactNode }) => {
	const { t } = useTranslation("components")
	const { logout } = useAuth()
	return (
		<div
			aria-label={t("appBlockScreen.ariaBlocking")}
			className="electron-drag absolute z-50 flex size-full flex-col items-center justify-center space-y-4 bg-base-900"
		>
			<p>{props.reason}</p>
			<Button trackingLabel="log_out" onClick={() => void logout()}>
				{t("appBlockScreen.logOut")}
			</Button>
		</div>
	)
}
